import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "admin-page-wr" }
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "breadcrumb-wrapper-main" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "current-breadcrumb" }
const _hoisted_6 = {
  key: 0,
  class: "card"
}
const _hoisted_7 = { class: "info-wr" }
const _hoisted_8 = { class: "block" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row-value" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "controls" }
const _hoisted_13 = { class: "wrapper-switch" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'AdminUser', params: { userId: $setup.userId } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.getFirstLastName($setup.user)), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "delimiter" }, null, -1)),
          _createVNode(_component_router_link, {
            to: { name: 'AdminEstate', params: { userId: $setup.userId, estateId: $setup.estateId } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.estate ? $setup.estate.title : ""), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "delimiter" }, null, -1)),
          _createElementVNode("div", _hoisted_5, "Stage " + _toDisplayString($setup.stage ? $setup.stage.title : ""), 1)
        ])
      ])
    ]),
    ($setup.stage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-title" }, "Stage:", -1)),
                _createElementVNode("div", _hoisted_10, _toDisplayString($setup.stage.title), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-title" }, "Status:", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["badge", $setup.getStageStatusClass($setup.stage.status)])
                }, _toDisplayString($setup.stage.status), 3)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              class: "button default edit",
              to: { name: 'AdminStageUpdate', params: { userId: $setup.userId, estateId: $setup.estateId, stageId: $setup.stageId } }
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Edit Stage", -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createVNode($setup["SwitchComponent"], {
        modelValue: $setup.currentTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.currentTab) = $event)),
        list: $setup.tabs,
        slots: ['customSwitch']
      }, {
        customSwitch: _withCtx((item) => [
          _createElementVNode("span", {
            class: "switch-item--text",
            onClick: ($event: any) => ($setup.toTab(item.label))
          }, _toDisplayString(item.label), 9, _hoisted_14)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_router_view, {
      role: $setup.UserRoles.SUPER_ADMIN
    }, null, 8, ["role"])
  ]))
}